/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import styles from "./ButtonsProject.module.scss";
import LoadingDots from "../Loading/LoadingDots";
import { ReactComponent as Planos } from "../../../assets/svg/planos.svg";
import { ReactComponent as Plantilla } from "../../../assets/svg/plantilla.svg";
import { ReactComponent as Subir } from "../../../assets/svg/presupuesto.svg";
import { ReactComponent as Warning } from "../../../assets/svg/modalAtencion.svg";
import { ReactComponent as Edit } from "../../../assets/svg/edit-proyects.svg";
import { connect } from "react-redux";
import { sendBudget, sendQuotationPostulation, getSubProjectBudgets } from "../../../store/actions";
import { fireAnalytics } from "../../../utils/firebase";
import NewModal from "../NewModal/NewModal";
import { useHistory } from "react-router-dom";

const ButtonsProject = ({
  onClick,
  subproyecto,
  isPostulating,
  isAllowed,
  sendBudget,
  userData,
  type,
  sendQuotationPostulation,
  getSubProjectBudgets,
  mainProjectId,
  subProjectBudgets,
  mainProject,
  isMyProject,
}) => {

  const [fileName, setFileName] = useState(
    (subproyecto && subproyecto.fileName) || ""
  );
  const [fileUpload, setFileUpload] = useState(false);
  const [newModalOpen, setNewModalOpen] = useState(false);
  const [hasSentBudgets, setHasSentBudgets] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const dsa = type === "subquotation" ? "quotation_payroll" : "budget_payroll";
  const projectIdWithSubprojectName = mainProjectId + '_' + subproyecto.name;

  //Definimos si es una cotizacion o un presupuesto
  const isQuotation = type === "subquotation";

  useEffect(() => {
    if (subproyecto && subproyecto.status === "SEND") {
      setFileUpload(true);
    }
  }, [subproyecto]);

  useEffect(() => {
    getSubProjectBudgets(subproyecto.id);
  }, []);

  const handlePostulating = () => {
    setNewModalOpen(!newModalOpen);
  };

  const uploadFile = (file) => {
    setFileName(file.name);
    setFileUpload(true);
    if (type === "subquotation") {
      sendQuotationPostulation(file, subproyecto.id);
      return;
    }
    sendBudget(file, subproyecto.id, projectIdWithSubprojectName);
  };

  //Definimos si ya se envio un presupuesto
const hasSentBudgetForSubproject = (subprojectId) => {
  return subProjectBudgets[subprojectId]?.some(
    (budget) => budget.user.id === userData.id
  );
};

useEffect(() => {
  setHasSentBudgets((prev) => ({
    ...prev,
    [subproyecto.id]: hasSentBudgetForSubproject(subproyecto.id),
  }));
   setTimeout(() => {
  setIsLoading(false);
}, 3000);

}, [subProjectBudgets]);

const hasSentBudget = hasSentBudgets[subproyecto.id] || false;

  //Definimos ruta para redirecionar al usuario 
  const userFullName = userData.type === "COMPANY" ? userData.razon_social : userData.name + " " + userData.last_name;
  const route = `/comunidad-edify/${userData.id}/${userFullName}`;

  return (
    <div className={styles.buttonsContainer}>
       {isMyProject ? (       
        type !== "subquotation" && subproyecto?.link !== "" && (
          <div className={styles.containterFlex}>
          <div className={styles.planosNoIcon}>
            <p className={styles.planosNoIcon_buttonText}>Link de acceso a los planos:</p>
            {subproyecto.link}           
          </div>
          <div className={styles.planosNoIcon}>
          <p className={styles.planosNoIcon_buttonText}>Planilla de cotización:</p> {subproyecto.fileName}
          </div>       
          </div>
        )) : (

          <div className={styles.containterFlex}>
            <NewModal
              onClick={handlePostulating}
              Icon={Warning}
              description={
                "Debes postularte y ser aceptado para tener acceso a los archivos de la publicación."
              }
              opened={newModalOpen}
              buttonSend={{ title: "¡Quiero postularme!", onClick: onClick }}
              title={"Atención"}
              buttonBack={{ title: "Cerrar", onClick: handlePostulating }}
            />

            {type !== "subquotation" && subproyecto?.link !== "" && (
              <a
                disabled={isAllowed !== "ALLOWED"}
                className={`${styles.planos} ${isAllowed !== "ALLOWED" ? styles.disabled : ""
                  }`}
                href={
                  isAllowed !== "ALLOWED"
                    ? null
                    : `${subproyecto.link && subproyecto.link.includes("http")
                      ? subproyecto.link
                      : `http://${subproyecto.link}`
                    } `
                }
                onClick={
                  isAllowed === "ALLOWED"
                    ? () =>
                      fireAnalytics("download_blueprints", {
                        category: "budgeting",
                      })
                    : () => handlePostulating()
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <Planos />
                <p className={styles.planos_buttonText}>
                  Link de acceso a los planos</p>
              </a>
            )}
            {subproyecto?.budget_payroll === null ? null :
              (<a
                disabled={isAllowed !== "ALLOWED" && !isQuotation}
                href={isAllowed !== "ALLOWED" && !isQuotation ? null : subproyecto[dsa]}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.plantilla} ${isAllowed !== "ALLOWED" && !isQuotation ? styles.disabled : ""
                  }`}
                onClick={
                  isAllowed === "ALLOWED" || isQuotation
                    ? () =>
                      fireAnalytics("download_template", { category: "budgeting" })
                    : () => handlePostulating()
                }
              >
                <Plantilla />
                <p className={styles.plantilla_buttonText}>Descargar planilla de cotización</p>
              </a>
              )}
            
            <div className={`${styles.newPresupuesto} ${hasSentBudget ? styles.disabled : ""}`}>
              <label
                htmlFor={`subir${subproyecto.id}`}
                className={`${styles.presupuesto} ${isAllowed !== "ALLOWED" && !isQuotation ? styles.disabled : ""
                  }`}
                onClick={
                  isAllowed === "ALLOWED" || isQuotation
                    ? () =>
                      fireAnalytics("upload_budget", { category: "budgeting" })
                    : () => handlePostulating()
                }
              >
                <Subir />
                {isLoading ? <LoadingDots blackDots /> : 
                hasSentBudget || fileUpload ? "Ya subiste un presupuesto" : "Subir presupuesto"}
              </label>
            </div>
          </div>
        )}
          <input
            disabled={(isAllowed !== "ALLOWED" && !isQuotation) || fileUpload}
            type="file"
            name={`subir${subproyecto.id}`}
            id={`subir${subproyecto.id}`}
            className={
              (isAllowed !== "ALLOWED" && !isQuotation) || fileName ? styles.inputDisabled : styles.input
            }
            onChange={(e) => {
              if (e.target.files[0]) {
                uploadFile(e.target.files[0]);
              }
            }}
            accept=".xlsx, .pdf, .xls"
          />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    subProjectBudgets: state.profile.subProjectBudgets,
  };
};

export default connect(mapStateToProps, {
  sendBudget,
  sendQuotationPostulation,
  getSubProjectBudgets,
})(ButtonsProject);


